export default __webpack_public_path__ + "static/media/loading.8d33dbc7.gif";